import { generatePath } from 'react-router-dom';
import {
  FC_WORKLIST_PATH_TEMPLATE,
  FC_VERIFICATION_DETAIL_PATH_TEMPLATE,
  FC_PREQUOTE_DETAIL_PATH_TEMPLATE,
} from './routeConfig';

/**
 * Build the category-worklist path, optionally preserving the current center scope.
 *
 * `center` is forwarded as a `?center=` query param ('' / undefined = All Centers, omitted).
 */
export function buildWorklistPath(type: string, center?: string): string {
  const path = generatePath(FC_WORKLIST_PATH_TEMPLATE, { type });

  if (!center)
    return path;

  const query = new URLSearchParams({ center }).toString();
  return `${path}?${query}`;
}

/**
 * Build the Verify Detail path for a case. `id` is the composite `company-center-visitKey`.
 */
export function buildVerificationDetailPath(id: string): string {
  return generatePath(FC_VERIFICATION_DETAIL_PATH_TEMPLATE, { id });
}

/** Build the Pre-Quote detail path (spec 057). `id` is the pre-quote's own composite id. */
export function buildPreQuoteDetailPath(id: string): string {
  return generatePath(FC_PREQUOTE_DETAIL_PATH_TEMPLATE, { id });
}

